import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-navy border-t border-gray-800 py-8 px-6 text-center" data-id="element-67">
      <div className="max-w-4xl mx-auto space-y-2" data-id="element-68">
        <p className="text-sm text-gray-400" data-id="element-69">
          © {new Date().getFullYear()} Edison Ricardo Ramírez · Visa Master ·
          Todos los derechos reservados
        </p>
        <p className="text-xs text-gray-500" data-id="element-70">
          Este producto es un recurso educativo y no constituye asesoría legal
          migratoria.
        </p>

        <div className="pt-6 mt-6 border-t border-gray-800/60 space-y-4 text-left md:text-center" data-id="element-71">
          <p className="text-xs text-gray-500" data-id="element-72">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-73">
              Términos y Condiciones
            </a>
            <span className="mx-2 text-gray-700" data-id="element-74">|</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-75">
              Política de Privacidad
            </a>
            <span className="mx-2 text-gray-700" data-id="element-76">|</span>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-77">
              Política de Reembolso
            </a>
          </p>

          <p className="text-xs text-gray-500 leading-relaxed max-w-3xl mx-auto" data-id="element-78">
            <span className="font-semibold text-gray-400" data-id="element-79">AVISO LEGAL:</span>{' '}
            Visa Master es un recurso educativo de preparación personal para
            entrevistas consulares. No constituye asesoría legal migratoria ni
            garantiza la aprobación de ninguna visa. Los resultados individuales
            dependen del perfil migratorio de cada solicitante. Este producto no
            está afiliado ni es representante oficial de ninguna embajada,
            consulado ni gobierno. Al realizar tu compra aceptas los términos y
            condiciones del servicio.
          </p>

          <p className="text-xs text-gray-500 leading-relaxed max-w-3xl mx-auto" data-id="element-80">
            <span className="font-semibold text-gray-400" data-id="element-81">
              Política de Reembolso:
            </span>{' '}
            Si dentro de los 7 días posteriores a tu compra sientes que el
            protocolo no cumplió con lo prometido, escríbenos a{' '}
            <a href="mailto:visamaster.edison@gmail.com" className="text-gold hover:underline" data-id="element-82">
              visamaster.edison@gmail.com
            </a>{' '}
            y te devolvemos el 100% de tu dinero sin preguntas ni formularios.
          </p>
        </div>
      </div>
    </footer>;
};